<template>
  <div class="audio-timecode-item" :class="isActive && 'audio-timecode-item--active'">
    <transition name="audio-timecode-item__animation-opacity">
      <IndicatorPoint class="audio-timecode-item__indicator" v-if="isActive"/>
    </transition>
    <p class="audio-timecode-item__txt">{{ text }}</p>
    <time class="audio-timecode-item__time">{{ time }}</time>
  </div>
</template>

<script setup>
  import { IndicatorPoint } from "@/Groups/Audioplayer/private/imports/externalTemplates";
  //--------------------------------
  const props = defineProps({
    //Активный таймкод?
    isActive: { type: Boolean },
    //Текст таймкода
    text: { type: String },
    //Время таймкода
    time: { type: String }
  });
</script>

<style scoped lang="scss">
  @import './styles';
</style>